import { render, staticRenderFns } from "./layout-combined-black.vue?vue&type=template&id=3c7772d0&scoped=true&"
import script from "./layout-combined-black.vue?vue&type=script&lang=js&"
export * from "./layout-combined-black.vue?vue&type=script&lang=js&"
import style0 from "./layout-combined-black.vue?vue&type=style&index=0&id=3c7772d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7772d0",
  null
  
)

export default component.exports